import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateIntegrationQuery } from './useGetExternalIntegration';

export enum RestartAfterSaveOutcome {
	Restarted = 'Restarted',
	NotStarted = 'NotStarted',
	KeptSuspended = 'KeptSuspended',
	KeptSuspendedWithError = 'KeptSuspendedWithError',
}

export interface IRestartAfterSaveResult {
	outcome: RestartAfterSaveOutcome;
}

export const usePostExternalIntegrationRestartAfterSaveMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRestartAfterSaveResult) => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ integrationProvider }: { integrationProvider: Api.IntegrationProvider }) => {
			return userSession.webServiceHelper.callAsync<IRestartAfterSaveResult>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/restartAfterSave`,
				}),
				'POST'
			);
		},
		onError,
		onSuccess,
		// A restart can stop the running sync and then fail, so the ETL state is refetched either way
		onSettled: (_result, _error, { integrationProvider }) =>
			invalidateIntegrationQuery({ impersonationContext, provider: integrationProvider }),
	});
};
